<template>
  <div>
    <p id="user-type" class="text-center font-bold">
      {{ userTypeNameStatic }}
    </p>
    <img
      v-if="photoSource"
      class="mx-auto max-h-[200px] max-w-[200px]"
      :src="photoSource"
      alt="Employee Photo"
    />
    <p
      v-else-if="photoMessage"
      class="mx-auto text-center text-sm text-gray-500"
      data-test="employee-photo-status"
    >
      {{ photoMessage }}
    </p>
    <div class="mt-4 w-full text-center">
      <p>{{ userFullName }}</p>
      <p>{{ contractorName }}</p>
      <p>{{ entryDate }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { documentStatusMessage } from '@/types/documents'
  import { useEmployeePhotoStore } from '@/storage/employeePhoto'
  import { useUserStore } from '@/storage/user'
  import { computed } from 'vue'
  import { useUserVisitorCompaniesStore } from '@/storage/userVisitorCompanies'
  import dayjs from 'dayjs'
  import { useUserLogin } from '@/storage/userLogin'

  const { fullName, selectedContractorCompanyName, userType, checkedInTime } =
    storeToRefs(useUserStore())

  const { isVisitor } = storeToRefs(useUserLogin())
  const isVisitorStatic = isVisitor.value

  const { photo } = storeToRefs(useEmployeePhotoStore())

  const photoSource = computed(() => photo.value?.content ?? null)

  const photoMessage = computed(() => {
    //show no message for users without a photo
    if (isVisitorStatic || photo.value === null) {
      return null
    }

    return documentStatusMessage(photo.value?.status ?? 'missing')
  })

  const getContractorName = computed(() => {
    return isVisitorStatic
      ? useUserVisitorCompaniesStore().lastSelected
      : selectedContractorCompanyName.value
  })
  const contractorName = getContractorName.value

  const userTypeNameStatic = userType.value.name
  const userFullName = fullName.value
  const entryDate = dayjs(checkedInTime.value).format('DD MMM YYYY [at] HH:mm')
</script>
